export default "__VITE_ASSET__f263f546__"